import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Scrolls the main content area to the top on every route change.
 * Place inside BrowserRouter but outside Routes.
 */
export function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Scroll the window to the top — handles both the page and any
    // overflow container that is the actual scroll parent.
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}
